
import GlobalFooter from '../../../components/feature/GlobalFooter';

export default function Footer() {
  return <GlobalFooter />;
}
